<div class="card mt-4">
  <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbHome"></p-breadcrumb>
</div>

<div class="card mt-4 p-4">
  <div class="w-full md:w-auto">
    <h3 class="font-semibold text-xl mb-2">Options des filtrages</h3>
  </div>

  <br><br>

  <div class="flex flex-col md:flex-row gap-4 mb-6 items-center justify-between border-b border-gray-200 pb-4">
    <div class="w-full md:w-auto flex-1">
      <p-dropdown [options]="facturationTypes" [(ngModel)]="radioValue"
                  optionLabel="label" optionValue="value" name="facturationType"
                  (onChange)="onTypeChange()" [style]="{'width':'100%'}" placeholder="Type de facturation">
      </p-dropdown>
    </div>

    <div class="w-full md:w-auto flex-1">
      <p-dropdown [options]="filteredDoList" [(ngModel)]="selectedDo"
                  [filter]="true" filterBy="label" placeholder="Sélectionnez un DO"
                  optionLabel="label" (onChange)="loadPreviewData()" [style]="{'width':'100%'}">
        <ng-template pTemplate="selectedItem">
          <div class="flex items-center">
            <i class="pi pi-tag mr-2"></i>
            <span>{{ selectedDo.label }}</span>
          </div>
        </ng-template>
        <ng-template let-do pTemplate="item">
          <div class="flex items-center">
            <i class="pi pi-tag mr-2"></i>
            <span>{{ do.label }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <div class="flex flex-col items-center justify-center gap-4 mb-6 border-b border-gray-200 pb-4">
    <div class="w-full flex justify-center">
      <p-datepicker [(ngModel)]="selectedMonth"
                    [showIcon]="true"
                    inputId="monthPicker"
                    view="month"
                    dateFormat="mm/yy"
                     [minDate]="minMonth"
                     [maxDate]="maxMonth"
                    [yearNavigator]="true"
                    yearRange="2020:2030"
                    [readonlyInput]="true"
                    placeholder="Sélectionnez un mois"
                    [monthNavigator]="true"
                    (onSelect)="onMonthChange()"
                    [style]="{'width':'300px'}">
      </p-datepicker>
    </div>

    <small *ngIf="validateMonth()" class="p-error block mt-1 text-center">
      Le mois en cours ne peut pas être sélectionné. Veuillez choisir un mois antérieur.
    </small>

    <div class="w-full flex justify-center mt-2">
      <button pButton
              type="button"
              label="Exporter"
              icon="pi pi-download"
              (click)="exportClientReport()"
              [disabled]="!radioValue || !selectedMonth || isLoading"
              [loading]="isLoading"
              styleClass="p-button-primary">
      </button>
    </div>
  </div>

  <div class="mb-6" *ngIf="showPreviewTable">
    <h4 class="text-lg font-semibold mb-3 text-center">Prévisualisation</h4>
    <div class="border border-gray-200 rounded">
      <p-table [value]="previewData" [loading]="loadingPreview" [responsive]="true" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of previewColumns" class="text-center">
              {{col}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td *ngFor="let col of previewColumns" class="text-center">
              {{rowData[col]}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-toast></p-toast>
